// Featued Products Slider
$(document).ready(function() {
  new Swiper('.featured-collection-slider', {
      loop: true,
      speed: 1000,
      navigation: {
        nextEl: ".featured-next",
        prevEl: ".featured-prev"
      },
      slidesPerView: 3,
      spaceBetween: 20,
      breakpoints: {
          1028: {
              slidesPerView: 3,
              spaceBetween: 26
          },
          480: {
              slidesPerView: 2,
              spaceBetween: 16
          },
          0: {
              slidesPerView: 1.99,
              spaceBetween: 16
          }
      }
  });
});

// Home Blog Slider
document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(max-width: 749px)').matches) {
    new Swiper('.featured-blog-slider', {
      loop: true,
      slidesPerView: 1,
      speed: 1000,
      spaceBetween: 8,
      navigation: {
        nextEl: ".blog-next",
        prevEl: ".blog-prev"
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 8
        }
      }
    });
  }
});

//Icon With Text Slider
document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(max-width: 749px)').matches) {
    new Swiper('.icon-with-text-slider', {
      loop: true,
      slidesPerView: 1,
      speed: 1000,
      spaceBetween: 8,
      navigation: {
        nextEl: ".icon-text-next",
        prevEl: ".icon-text-prev"
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 8
        }
      }
    });
  }
});

//instagram Image Slider
$(document).ready(function() {
  new Swiper('.instagram-slider', {
      loop: true,
      speed: 1000,
      navigation: false,
      slidesPerView: 3,
      spaceBetween: 14,
      autoplay: {
         delay: 2000,
     },
      breakpoints: {
          1441: {
              slidesPerView: 5
          },
          1028: {
              slidesPerView: 4
          },
          749: {
              slidesPerView: 3
          },
          0: {
              slidesPerView: 2
          }
      }
  });
});

// pdp page 
// setTimeout(function() {
//     var sellingPlans = document.querySelector(".recharge-subscription-widget .rc-selling-plans");
//     var targetLabel = document.querySelector(".subscription-radio span");

//     if (sellingPlans && targetLabel) {
//         targetLabel.parentNode.insertBefore(sellingPlans, targetLabel.nextSibling);
//     }
// }, 1000);


document.addEventListener('DOMContentLoaded', () => {
  const mainPopup = document.getElementById('main-popup');
  const videoElement = mainPopup.querySelector('video');
  const videoSource = videoElement.querySelector('source');
  const originalVideoSrc = videoSource.src;
  // const openMainPopupBtn = document.getElementById('open-main-popup');
  const openPopupButtons = document.querySelectorAll("#open-main-popup");
  const closeMainPopupBtn = document.getElementById('close-main-popup');

  // Open main popup and play video

  openPopupButtons.forEach(function(openMainPopupBtn){
    openMainPopupBtn.addEventListener('click', () => {
      console.log("click on btn");
      const videoSrcWithAutoplay = `${originalVideoSrc}?autoplay=1`;
      console.log("video_url",videoSrcWithAutoplay);
      videoSource.src = videoSrcWithAutoplay; // Update video source with autoplay
      videoElement.load(); // Reload the video
      videoElement.play(); // Start playback
      mainPopup.style.display = 'flex';
      document.body.classList.add("overflow-hidden");
    });
  });
 

  // Close main popup and stop/reset video
  closeMainPopupBtn.addEventListener('click', () => {
    mainPopup.style.display = 'none';
    videoElement.pause(); // Pause the video
    videoSource.src = originalVideoSrc; // Reset video source
    videoElement.load(); // Reload with the original source
    document.body.classList.remove("overflow-hidden");
  });

  // Close popup when clicking outside
  window.addEventListener('click', (e) => {
    if (e.target === mainPopup) {
      mainPopup.style.display = 'none';
      videoElement.pause(); // Pause the video
      videoSource.src = originalVideoSrc; // Reset video source
      videoElement.load(); // Reload with the original source
      document.body.classList.remove("overflow-hidden");
    }
  });

});

// start save amount show hide based on subscription
document.addEventListener("DOMContentLoaded", function () {

  


  function updatePurchaseOption(selectedValue) {
    document.querySelectorAll(".name_swatch").forEach((label) => {
      const subscribeElement_sub = label.querySelector(".cst_price .variant-save_pr.subscribe");
      const subscribeElement_one = label.querySelector(".cst_price .variant-save_pr.onetime");

      const subscribeElement_sub_title = label.querySelector(".text_info .variant-save_pr.subscribe");
      const subscribeElement_one_title = label.querySelector(".text_info .variant-save_pr.onetime");

      const subscribeElement_subPrice = label.querySelector(".cst_price .variant-price.subscribe");
      const subscribeElement_onePrice = label.querySelector(".cst_price .variant-price.onetime");

      const priceElement = label.querySelector(".cst_price");
console.log("==>",selectedValue);
      
      if (selectedValue === "onetime") {
        console.log("if onetime");
        if (subscribeElement_sub) subscribeElement_sub.classList.add("hide");
        if (subscribeElement_sub_title) subscribeElement_sub_title.classList.add("hide");
        if (subscribeElement_subPrice) subscribeElement_subPrice.classList.add("hide");

        if (subscribeElement_one) subscribeElement_one.classList.remove("hide");
        if (subscribeElement_one_title) subscribeElement_one_title.classList.remove("hide");
        if (subscribeElement_onePrice) subscribeElement_onePrice.classList.remove("hide");

        if (priceElement) {
          const variant_compair_price = priceElement.getAttribute("data-vcomparprice");
          const variant_price = priceElement.getAttribute("data-VpriceOnetime");
          const variantPriceElement = priceElement.querySelector(".variant-price.onetime.compair");

          if (variantPriceElement) {
            if (variant_compair_price === variant_price) {
              variantPriceElement.classList.add("hide");
            } else {
              variantPriceElement.classList.remove("hide");
            }
          }
        }
      } else {
        console.log("else sub");
        if (subscribeElement_sub) subscribeElement_sub.classList.remove("hide");
        if (subscribeElement_sub_title) subscribeElement_sub_title.classList.remove("hide");
        if (subscribeElement_subPrice) subscribeElement_subPrice.classList.remove("hide");

        if (subscribeElement_one) subscribeElement_one.classList.add("hide");
        if (subscribeElement_one_title) subscribeElement_one_title.classList.add("hide");
        if (subscribeElement_onePrice) subscribeElement_onePrice.classList.add("hide");

        if (priceElement) {
          const variant_compair_price = priceElement.getAttribute("data-vcomparprice");
          const variant_price = priceElement.getAttribute("data-Vpricesubscribe");
          const variantPriceElement = priceElement.querySelector(".variant-price.onetime.compair");

          if (variantPriceElement) {
            if (variant_compair_price === variant_price) {
              variantPriceElement.classList.add("hide");
            } else {
              variantPriceElement.classList.remove("hide");
            }
          }
        }
      }
    });
  }

  // Ensure the function runs on page load after DOM is fully loaded
  function runOnPageLoad() {
    setTimeout(() => {
      const selectedRadio = document.querySelector('input[name="purchaseOption"]:checked');
      if (selectedRadio) {
        console.log("Running on page load with selected value:", selectedRadio.value);
        updatePurchaseOption(selectedRadio.value);
      } else {
        console.log("No radio button selected on page load. Setting default.");
        const defaultRadio = document.querySelector('input[name="purchaseOption"]');
        if (defaultRadio) {
          defaultRadio.checked = true; // Set a default selection
          console.log("==>",defaultRadio.value);
          updatePurchaseOption(defaultRadio.value);
          
        }
      }


      var is_name_swatch = document.querySelectorAll(".name_swatch input[type='radio']:checked");
       if(is_name_swatch){
         document.querySelectorAll(".name_swatch input[type='radio']:checked").forEach((radio) => {
          const nextElement = radio.nextElementSibling;
            if (nextElement) {
              nextElement.querySelectorAll(".variant-save_pr").forEach((element) => {
                const style = window.getComputedStyle(element);
                if (style.display !== "none" && style.visibility !== "hidden" && style.visibility !== "hide" && style.opacity !== "0") {
                  var rc_percentage = element.getAttribute("data-spr"); // Get the value dynamically
                   // Select the label and set a custom data attribute
                  document.addEventListener("DOMContentLoaded", function () {
                    const label = document.querySelector(".subscription-radio[for=rc-radio2] span.rc-radio__label");
                    if (label) {
                      label.setAttribute("data-content", `Subscribe & Save ${rc_percentage}`);
                    }
                    // Inject CSS that reads from `data-content`
                    const style = document.createElement("style");
                    style.innerHTML = `
                    .subscription-radio[for=rc-radio2] span.rc-radio__label::after {
                    content: attr(data-content) !important;
                    }
                    `;
                    document.head.appendChild(style);
                  });
                }
              });
            }
         });
       }
      
    }, 500); // Ensures the elements are fully loaded before running

    
  }

  // radio change
  function attachEventListeners() {
    document.querySelectorAll('input[name="purchaseOption"]').forEach((radio) => {
      radio.addEventListener("change", (event) => {
        console.log("Radio changed:", event.target.value);
        updatePurchaseOption(event.target.value);
      });
    });
  }
  runOnPageLoad(); // Run on page load
  attachEventListeners(); // Attach event listeners


  var isALARendered;
function ALAcheck() {
  isALARendered = setInterval(function () {
    customALA()
  }, 500);
}
ALAcheck();
function customALA() {
var selector = $('.rc-widget');
  if(selector.length > 0) {
    clearInterval(isALARendered);        
    attachEventListeners();

    const discountLabels = document.querySelectorAll(".discount-label");
    discountLabels.forEach(span => {
    const discount_label = span.textContent.trim()
    if (discount_label.includes("Subscribe ")) { // Corrected condition
        span.textContent = "Subscribe & Save"; // Update the text
    }
    });


    document.querySelectorAll(".name_swatch input[type='radio']").forEach((radio) => {
    radio.addEventListener("change", function () {
        // Find all discount-label elements (even if in a different block)
        document.querySelectorAll(".discount-label").forEach(span => {
            const discount_label = span.textContent;
          console.log(discount_label);
          setTimeout(function(){
            if (discount_label.includes("Subscribe ")) {
                span.textContent = "Subscribe & Save"; // Update the text
            }
            },100);
        });
    });
   });

     // added here 


    document.querySelectorAll('input[name="purchaseOption"]').forEach((radio) => {
      radio.addEventListener("change", (event) => {
        console.log("Radio changed:", event.target.value);
        updatePurchaseOption(event.target.value);
        document.querySelectorAll(".name_swatch input[type='radio']:checked").forEach((radio) => {
           const nextElement = radio.nextElementSibling;
          if (nextElement) {
            nextElement.querySelectorAll(".variant-save_pr").forEach((element) => {
              const style = window.getComputedStyle(element);
              if (style.display !== "none" && style.visibility !== "hidden" && style.visibility !== "hide" && style.opacity !== "0") {
                var rc_percentage = element.getAttribute("data-spr"); // Get the value dynamically
                console.log("rc_percentage:--",rc_percentage);
                // Select the label and set a custom data attribute
                const label = document.querySelector(".subscription-radio[for=rc-radio2] span.rc-radio__label");
                if (label) {
                    label.setAttribute("data-content", `Subscribe & Save ${rc_percentage}`);
                }
                
                // Inject CSS that reads from `data-content`
                const style = document.createElement("style");
                style.innerHTML = `
                  .subscription-radio[for=rc-radio2] span.rc-radio__label::after {
                    content: attr(data-content) !important;
                  }
                `;
                document.head.appendChild(style);
            }

            });
        
          }
        });
      });
    });
  }  
}
});




// end save amount show hide based on subscription